<template>
    <div>
        <Modal v-model="modalShow" @on-cancel="onCancel">
            <Form ref="formValidate" style="margin-top:30px" :model="formData" :rules="rules" :label-width="80">
                <FormItem label="导入日期" prop="importDate">
                    <DatePicker type="date" :value="formData.importDate" @on-change="onImportDate" style="width:180px"></DatePicker>
                </FormItem>
                <FormItem label="上传Excel">
                    <plt-upload ref="excelRef" @success="uploadSuccess" :multiple="false" :format="['xls','xlsx','csv']" :height="70" :width="300" title="上传Excel" @delete="onDelete"></plt-upload>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="submit">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import pltUpload from '@/components/upload/upload.vue'
export default {
    components: { pltUpload },
    data() {
        return {
            modalShow: false,
            formData: {
                fileId: "",
                importDate: '',
            },
            rules: {
                importDate: [{ required: true, message: "请选择导入日期" }]
            }
        }
    },
    methods: {
        openModal() {
            this.modalShow = true;
            this.formData.importDate = new Date().formatDate();
        },
        onImportDate(val) {
            this.formData.importDate = val;
        },
        uploadSuccess({ body }) {
            this.formData.fileId = body;
        },
        onDelete() {
            this.formData.fileId = "";
        },
        onCancel() {
            this.modalShow = false;
            this.$refs['formValidate'].resetFields()
            this.$refs['excelRef'].$refs['uploadFile'].clearFiles()
        },
        async submit() {
            let valid = await this.$refs['formValidate'].validate();
            if (!valid)
                return;
            if (!this.formData.fileId)
                return this.$Message.warning('请上传Excel');
            let data = {
                url: "http://MID-OPERATE-LEASE/messageService/deliverImportService/importDeliverLogs",
                body: this.formData
            }
            this.invoke(data,true).then(({importRows,deliverRows}) => {
                this.$Notice.success({
                    title: '操作成功',
                    desc:`新增数据${importRows}条,自动转户成功${deliverRows}条,请核对.`,
                    duration:0
                });
                this.onCancel()
                this.$emit('query')
            })
        }
    }

}
</script>

<style lang="sass" scoped>
</style>